<style>
    .videoWrapper {
        position: relative;
        padding-bottom: 56.25%;
        /* 16:9 */
        padding-top: 25px;
        height: 0;
    }

    .videoWrapper iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0
    }
</style>
<div class="main-content">
    
    <div class="row">
            <div class="col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Collapsible Accordion</h4>
                            <p class="category">Bootstrap default style</p>
                        </div>
                        <div class="card-content">
                           <div id="acordeon">
                                <div class="panel-group" id="accordion">
                                    <div class="panel panel-border panel-default">
                                        <a data-toggle="collapse" href="#collapseOne" class="collapsed" aria-expanded="false">
                                            <div class="panel-heading">
                                                <h4 class="panel-title">
                                                    Default Collapsible Item 1
                                                    <i class="ti-angle-down"></i>
                                                </h4>
                                            </div>
                                        </a>
                                        <div id="collapseOne" class="panel-collapse collapse" aria-expanded="false" style="height: 0px;">
                                            <div class="panel-body">
                                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-border panel-default">
                                        <a data-toggle="collapse" href="#collapseTwo">
                                            <div class="panel-heading">
                                                <h4 class="panel-title">
                                                    Default Collapsible Item 1
                                                    <i class="ti-angle-down"></i>
                                                </h4>
                                            </div>
                                        </a>
                                        <div id="collapseTwo" class="panel-collapse collapse">
                                            <div class="panel-body">
                                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="panel panel-border panel-default">
                                        <a data-toggle="collapse" href="#collapseThree">
                                            <div class="panel-heading">
                                                <h4 class="panel-title">
                                                    Default Collapsible Item 1
                                                    <i class="ti-angle-down"></i>
                                                </h4>
                                            </div>
                                        </a>
                                        <div id="collapseThree" class="panel-collapse collapse">
                                            <div class="panel-body">
                                                Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div><!--  end acordeon -->
                        </div>
                    </div>
                </div>
    </div>
</div>